import { isEmpty } from "ramda";

const getFields = (values) => {
  let fields = [];
  const files = [];
  if (values) {
    const keys = Object.keys(values);
   
    keys.forEach((key, index) => {
      let obj = {};
      if (
        typeof values[key] === "object" &&
        !Array.isArray(values[key]) &&
        values[key].type &&
        !values[key].size
      ) {
        const { name, type, fields, label } = values[key];
        obj["name"] = name;
        obj["type"] = type;
        obj["label"] = label;
        obj["values"] = getFields(fields).fields;
      } else if (typeof values[key] === "string" || typeof values[key] === "number") {
        obj["name"] = key;
        obj["value"] = values[key];
      } else if ( // handle array values that are not files
        Array.isArray(values[key]) &&
        values[key].length &&
        (!(values[key][0] instanceof File))
      ) {
        obj["name"] = key;
        obj["value"] = values[key];
      } else if ( // handle array values that are files
        typeof values[key] === "object" &&
        Array.isArray(values[key]) &&
        values[key].length &&
        values[key][0] instanceof File
      ) {
        values[key]?.forEach( value => {
          const fileObj = {};
          fileObj["name"] = key;
          fileObj["value"] = value;
          files.push(fileObj);
        })
      } else if (
        typeof values[key] === "object" &&
        !Array.isArray(values[key]) &&
        values[key].size
      ) {
        const fileObj = {};
        fileObj["name"] = key;
        fileObj["value"] = values[key];
        files.push(fileObj);
      }

      fields.push(obj);
    });
  }

  fields = fields.filter((item) => !isEmpty(item));

  return { fields, files };
};

export default getFields;
